import { CURRENT_VIEW } from "../_types/navType";

export const setCurrentView = (view) => async (dispatch) => {
  //console.log(`set view ${view}`);
  dispatch({ type: CURRENT_VIEW, payload: view });
};
